<template>
    <div>
        <div class="row">
            <div class="col">
                <div class="form-group p-1">
                    <label class="control-label" for="company_id">{{transEdit('therapist')}}</label>
                    <input type="text" class="form-control" name="therapist_name" id="therapist-autocomplete" />
                    <input v-model="therapist_id" type="hidden" class="form-control" id="therapist_id" name="therapist_id">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group p-1">
                    <label class="control-label" for="absence_start">{{transEdit('Från')}}</label>
                    <input v-model="absence_start" type="datetime-local" class="form-control" name="absence_start" id="absence_start" />
                </div>
            </div>
            <div class="col">
                <div class="form-group p-1">
                    <label class="control-label" for="absence_end">{{transEdit('Till')}}</label>
                    <input v-model="absence_end" type="datetime-local" class="form-control" name="absence_end" id="absence_end" />
                </div>
            </div>
        </div>

        <div v-if="loading" class="row">
            <div class="col">
                <i>Laddar..</i>
            </div>
        </div>
        <div v-else-if="error" class="row">
            <div class="col">
                <i>{{ error }}</i>
            </div>
        </div>
        <div v-else-if="Object.keys(schedules_by_location).length > 0">
            <button @click="createAbsence" :disabled="!submitActive" class="btn btn-primary mb-2">Skapa vikariat</button>

            <h4>Matchande scheman</h4>
            <p>Systemet utlyser automatiskt ett vikariat per lokal.</p>

            <div v-for="(dates, location_id) in schedules_by_location" class="mt-2">
                <div v-for="(schedules, date) in dates" class="row">
                    <div class="col">
                        <h5>{{ date }}</h5>
                        <div>
                            <a :href="`/companies/${schedules[0].location.primary_company.id}`" target="_blank"><i class="fa fa-building"></i> {{ schedules[0].location.primary_company.name }}</a><br>
                            <a :href="`/locations/${schedules[0].location.id}`" target="_blank"><i class="fa fa-map-marker"></i> {{ schedules[0].location.address }}</a>
                        </div>
                        <div v-for="schedule in schedules" >
                            <input type="checkbox" @change="toogleSelectedSchedule(schedule.id)" :checked="scheduleIsSelected(schedule.id)">
                            <label>{{ formatTime(schedule.start) }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
    data() {
        return {
            loading: false,
            therapist_id: null,
            absence_start: null,
            absence_end: null,
            schedules_by_location: {},
            selected_schedules: [],
            error: null,
        };
    },

    watch: {
        async therapist_id() {
            await this.loadSchedules()
        },

        async absence_start() {
            await this.loadSchedules()
        },

        async absence_end() {
            await this.loadSchedules()
        }
    },

    computed: {
        submitActive() {
            return !this.loading && !this.error && Object.keys(this.schedules_by_location).length > 0;
        },
    },

    methods: {
        async createAbsence() {
            this.loading = true;

            const result = await axios.post('/absences', {
                therapist_id: this.therapist_id,
                absence_start: this.absence_start,
                absence_end: this.absence_end,
                schedule_ids: this.selected_schedules,
            });

            if(result.data && result.data.status == 'error') {
                alert(result.data.message);
            } else {
                alert(`Skapade ${result.length} st vikariat.`);
                document.location.href = '/absences';
            }

            this.loading = false;
        },

        formatTime(time) {
            return moment(time).format('HH:mm');
        },

        async loadSchedules() {
            this.schedules_by_location = [];
            this.error = null;

            if(!this.therapist_id || !this.absence_start || !this.absence_end) {
                return;
            }

            this.loading = true;

            const result = await axios.get(`/absences-preview/${this.therapist_id}?absence_start=${this.absence_start}&absence_end=${this.absence_end}`);
            if(result.data && result.data.status == 'error') {
                this.error = result.data.message;
            } else {
                this.schedules_by_location = result;
            }

            this.initSelectedSchedules();

            this.loading = false;
        },

        initSelectedSchedules() {
            this.selected_schedules = [];

            for(const location_id in this.schedules_by_location) {
                for(const date in this.schedules_by_location[location_id]) {
                    for(const schedule of this.schedules_by_location[location_id][date]) {
                        this.selected_schedules.push(schedule.id);
                    }
                }
            }
        },

        toogleSelectedSchedule(schedule_id) {
            if(this.scheduleIsSelected(schedule_id)) {
                this.selected_schedules = this.selected_schedules.filter((s) => s != schedule_id);
            } else {
                this.selected_schedules.push(schedule_id);
            }
        },

        scheduleIsSelected(schedule_id) {
            return this.selected_schedules && this.selected_schedules.includes(schedule_id);
        },
    },

    mounted() {
        this.absence_start = moment().add(1, 'hour').startOf('hour').format('YYYY-MM-DD HH:mm');
        this.absence_end = moment().endOf('day').format('YYYY-MM-DD HH:mm');
    }
}
</script>


<style scoped>

</style>
